import React from 'react';
import { Title, Description } from '../../components/layouts';
import './style.scss';

export function VideoBrief({ mobile = false }) {

  return (
    <div className="page-section section-video-brief inverted">
      <div className="section-content title center">
        <Title>让你的导演梦，不是梦</Title>
        {/*<Description>*/}
        {/*  看别人的短片，不如开拍自己的短片，双主摄加持，装备稳稳到位；*/}
        {/*  <br/>*/}
        {/*  支持超清夜景视频，无论多晚都入戏。*/}
        {/*</Description>*/}
      </div>
    </div>
  );
}
